import React from "react";
import { AuthRoles } from "components/auth";

export const AccountsPayableConfig = {
  auth: AuthRoles.admin,
  routes: [
    {
      path: `${process.env.PUBLIC_URL}/accounts_payable`,
      component: React.lazy(() => import("./AccountsPayable")),
    },
  ],
};
